import { flow } from 'lodash';

import { NAME } from './fees.constant';

import { selectState as selectStatePdv } from '../pdv.selector';

const selectStateKey = (state) => state[NAME];
const selectLoadingKey = (state) => state.loading;
const selectDataKey = (state) => state.data;
const selectDataLinkKey = (state) => state.link_data;

export const selectState = flow(selectStatePdv, selectStateKey);
export const selectLoading = flow(selectState, selectLoadingKey);
export const selectData = flow(selectState, selectDataKey);
export const selectDataLink = flow(selectState, selectDataLinkKey);
